import { localeRedirectionMap } from 'root/global-wrappers/config';
import { LOCALE, REGION } from 'root/widgets/constants';

export const getLocalePathname = (locale: LOCALE, region: REGION) =>
  localeRedirectionMap[region]?.[locale] ?? `/${locale}`;
